import { useMutation, gql } from '@apollo/client';

import { GET_INTERVIEW_TYPES } from './get-interview-types.hook';

export const UPDATE_INTERVIEW_TYPE = gql`
  mutation updateInterviewType($interviewTypeId: ObjectId!, $payload: InterviewTypeInput!) {
    updateInterviewType(interviewTypeId: $interviewTypeId, payload: $payload) {
      _id
    }
  }
`;

export const useUpdateInterviewType = () => {
  const [updateInterviewType] = useMutation(UPDATE_INTERVIEW_TYPE, {
    refetchQueries: [GET_INTERVIEW_TYPES],
  });

  return updateInterviewType;
};
